import React, { useMemo } from 'react';
import styles from './Text.module.scss';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useIsRtl from '../../../app/helpers/isRtl';
// const rtlLanguages = ['ar', 'he', 'fa', 'ur', 'ps', 'sd', 'ckb', 'dv'];
const getTagFromVariant = (variant = '') => {
  const sizeMatch = variant.match(/-(\d{2})/);
  const size = sizeMatch ? parseInt(sizeMatch[1]) : null;

  if (!size) return 'div';

  if (size <= 20) return 'p';
  if (size <= 25) return 'h4';
  if (size <= 33) return 'h3';
  if (size <= 40) return 'h2';
  return 'h1';
};

const variantToTag = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  p: 'p',
  link: 'a',
  span: 'span',
  div: 'div',
};
const Text = ({
  id,
  title,
  style = {},
  variant = 'paragraph',
  isLineBreak = false,
  className = '',
  onClick,
  svg = null,
  svgPosition = 'left',
  link,
  component,
  colorReverse,
  svgStyle,
  onMouseEnter,
  ref,
  maxLines,
  color,
  textContainerStyle,
  fill,
  isTranslated = true,
  tag,
}) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isRtl = useIsRtl();
  const fontSize = useSelector((state) => state.fontSize);
  const classes = `${styles['text-container']} ${
    currentLanguage !== 'en' ? styles['text-container-rtl'] : ''
  } ${styles[variant] ?? ''} ${styles[fontSize] ?? ''} ${
    isLineBreak
      ? isRtl
        ? styles['has-line-break-right']
        : styles['has-line-break']
      : ''
  } ${currentLanguage !== 'en' ? 'rtl' : 'ltr'} ${className ?? ''}`;

  const containerStyles = {
    display: svg ? 'flex' : '',
    alignItems: 'center',
    gap: isRtl ? '10px' : '10px',
    color: color,
    ...(maxLines && {
      display: '-webkit-box',
      WebkitLineClamp: maxLines,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
    ...textContainerStyle,
    ...style,
    // textTransform: 'capitalize',
  };
  const text = typeof title === 'string' && isTranslated ? t(title) : title;
  const handleClick = (link) => {
    if (link) {
      window.open(link, '_blank');
    }
  };
  const resolveTag = () => {
    if (component) return 'div';
    if (tag && variantToTag[tag]) return variantToTag[tag];
    return getTagFromVariant(variant);
  };
  const Tag = useMemo(resolveTag, [component, tag, variant]);

  return (
    <Tag
      id={id}
      className={classes}
      style={containerStyles}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      ref={ref}
    >
      {svg && svgPosition === 'left' && (
        <img
          src={svg}
          alt="icon"
          className={styles['svg-icon-left']}
          style={{ ...svgStyle, filter: fill ?? null }}
        />
      )}
      {component || text}
      {!component && link && (
        <span
          className={`${colorReverse ? styles['link-green'] : styles['link']}`}
          onMouseEnter={onMouseEnter}
          onClick={() => handleClick(link)}
        >
          {t(link)}
        </span>
      )}
      {svg && svgPosition === 'right' && (
        <img
          src={svg}
          alt="icon"
          className={styles['svg-icon-right']}
          style={{ ...svgStyle, filter: fill }}
        />
      )}
    </Tag>
  );
};

export default Text;
